//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { taskActions } from '../../Task/TaskActions.js'

export default {
  name: 'RequestMapPopupTaskButtons',
  mixins: [taskActions],
  computed: {
    /*
      ПРАВИЛА ОТОБРАЖЕНИЯ КНОПОК
    */
    BS4_displayAcceptTaskForExecutionButton: function () {
      const user = this.$store.getters.getUser
      return (this.taskStatus == 'BS3' && (this.requestRoles.roleAdminOrRoot || this.requestRoles.roleContractorDispatcher || this.requestRoles.roleExecutor)) && (!user || !user.employee || user.employee.isContractor || !user.employee.brigadeId) // в мобильном интерфейсе оставлена только в EngineerTaskCard
    },
    BS13_displayRejectRequestAsContractorButton: function () {
      return this.request.actionsProps.BS13_RejectRequestAsExecutor
    },
    BS10_displayRequireAdditionalDepartureAsContractorButton: function () {
      if (this.isLastReportDeferred) {
        return false
      }
      return this.request.actionsProps.BS10_contractorDispatcher && this.taskStatus == 'BS8' && this.isContractorDispatcher
    }
  }
}
